/* eslint-disable no-undef */
import Draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['sourceType', 'sourceId'],

    components: {
        Draggable
    },

    data() {
        return {
            availableFilter: '',
            selectedFilter: '',
            items: [],
        }
    },

    beforeDestroy() {
        let services = this.projectServicesBySource({
            source_type: this.sourceType,
            source_id: this.sourceId
        })

        _.each(services, (service) => this.removeEditingProjectService(service))
    },

    methods: {
        ...mapActions([
            'reorderEditingProjectServices',
            'removeEditingProjectService',
            'addEditingProjectService',
            'restoreProjectService'
        ]),

        removeObjectWithId(arr, id) {
            const objWithIdIndex = arr.findIndex((obj) => obj.id === id);

            if (objWithIdIndex > -1) {
                arr.splice(objWithIdIndex, 1);
            }
            return arr;
        },

        addSelected(event) {
            let service = event.added
            let method = "addSelected"
            // let servicesCloned = _.cloneDeep(this.selectedServices)

            if (service !== undefined && service.element) {
                this.addEditingProjectService({
                    source_id: this.sourceId,
                    source_type: this.sourceType,
                    service_id: service.element.id,
                    type: this.type,
                    work_types: service.element.work_types,
                    arr: this.selectedServices
                })

                if (method === "addSelected") {
                    console.log("this.selectedServices", this.selectedServices);
                    this.selectedServices[this.selectedServices.length - 1].work_types = []
                }

                //move the last item to the first position
                let lastItem = event.added.newIndex

                let lastElement = this.selectedServices.pop(); // Remueve y devuelve el último elemento

                this.selectedServices.splice(lastItem, 0, lastElement); // Inserta el último elemento en el nuevo índice

                setTimeout(() => {
                    this.$store.state.projectServices.items = this.selectedServices
                }, 600)

            }

            if (event && event.moved) {
                let newPos = event.moved.newIndex
                let oldPos = event.moved.oldIndex

                if (oldPos >= 0 && oldPos < this.selectedServices.length &&
                    newPos >= 0 && newPos < this.selectedServices.length) {

                    let itemMoved = this.selectedServices.splice(oldPos, 1)[0];

                    this.selectedServices.splice(newPos, 0, itemMoved);
                    this.$store.state.projectServices.items = this.selectedServices

                } else {
                    console.log("Error: out of position");
                }
            }
        },

        restoreSelected(event) {
            let service = event.added


            if (service !== undefined && typeof service.element.id === "string" && service.element.id.startsWith('s')) {
                this.restoreProjectService({
                    services: service,
                })

                this.removeSelected(event)

            }

            if (service !== undefined && service.element.source_type) {
                this.restoreProjectService({
                    services: service,
                })

                this.removeSelected(event)

            }
        },

        reorder(event) {
            if (event.moved) {
                this.reorderEditingProjectServices({
                    newIndex: event.moved.newIndex,
                    oldIndex: event.moved.oldIndex
                })
            }
        },


        removeSelected(event) {
            this.removeEditingProjectService(event.added.element)
        }
    },

    computed: {
        ...mapGetters([
            'projectServicesBySource',
            'workTypesByIds',
            'serviceById'
        ]),

        selectedServices: {
            get() {
                return this.projectServicesBySource({
                    source_type: this.sourceType,
                    source_id: this.sourceId
                })
            },
            set() {
                console.log("set");
            }
        },

        isAvailableServiceHidden: () => (service, filter) => !service.title.toLowerCase().includes(filter.toLowerCase()),

        isSelectedServiceHidden: () => (service, filter) => !service.title.toLowerCase().includes(filter.toLowerCase())
    }
}
